import { List, Map } from 'immutable';
import MenuItemCostRecipe, { MenuItemCostRecipes } from 'records/MenuItemCostRecipe';
import BaseList from 'records/BaseList';

import {
  MENU_ITEM_COST_RECIPES_ASYNC_ACTION_START,
  MENU_ITEM_COST_RECIPES_ASYNC_ACTION_ERROR,
  MENU_ITEM_COST_RECIPES_ASYNC_UPDATE_SUCCESS,
  MENU_ITEM_COST_RECIPES_UPDATE_SEARCH,
  MENU_ITEM_COST_RECIPES_RESET_STATE,
} from 'actions/menuItemCostRecipes';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  filters: new Map({
    searchTerm: '',
  }),
  data: new List(),
});

const actionsMap = {
  [MENU_ITEM_COST_RECIPES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ITEM_COST_RECIPES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ITEM_COST_RECIPES_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    let menuItemCostRecipesData = MenuItemCostRecipes(action.data);
    menuItemCostRecipesData = MenuItemCostRecipe.mergeSelectedMenuItemCostRecipes(
      state.get('data'),
      menuItemCostRecipesData
    );

    return state.merge({
      loading: false,
      errorMessage: null,
      data: menuItemCostRecipesData,
    });
  },
  [MENU_ITEM_COST_RECIPES_UPDATE_SEARCH]: (state, action) => {
    const filters = state.filters.set('searchTerm', action.data);
    return state.merge({
      filters,
      data: state.data,
    });
  },
  [MENU_ITEM_COST_RECIPES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function menuItemCostRecipes(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
